import { render, staticRenderFns } from "./internationalCustomizeCardProduct.vue?vue&type=template&id=7a61a53d&scoped=true"
import script from "./internationalCustomizeCardProduct.vue?vue&type=script&lang=js"
export * from "./internationalCustomizeCardProduct.vue?vue&type=script&lang=js"
import style0 from "./internationalCustomizeCardProduct.vue?vue&type=style&index=0&id=7a61a53d&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7a61a53d",
  null
  
)

export default component.exports